import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons'

import { roundNumber } from '@/utils'
import { NutritionFactsGroupType } from './nutritionFactsList'
import { NutritionalValueFields } from './NutritionValueCalculator'

type Props = {
  group: NutritionFactsGroupType
  nutritionalValue: NutritionalValueFields
}

export default function NutritionFactsGroup({ group, nutritionalValue }: Props) {
  const [expanded, setExpanded] = useState(!group.expandable)

  const togglePanel = () => setExpanded(!expanded)

  const renderValue = (nValue: number, unit: string) => {
    if (nValue === 0) {
      return nValue
    } else if (isNaN(nValue) || typeof nValue === 'undefined') {
      return 'NA'
    } else {
      // Show decimals for values < 10
      const decPlaces = nValue < 10 ? 2 : 0
      const value = roundNumber(nValue, decPlaces)
      return `${value}${unit}`
    }
  }

  return (
    <div className="NutritionFacts-group">
      {group.expandable && (
        <div className="NutritionFacts-groupHeading" onClick={togglePanel}>
          {group.name}
          {expanded ? (
            <FontAwesomeIcon icon={faChevronUp} />
          ) : (
            <FontAwesomeIcon icon={faChevronDown} />
          )}
        </div>
      )}
      {expanded && (
        <ul className="NutritionFacts-list">
          {group.entries.map((entry) => (
            <li key={entry.id} className="NutritionFacts-row">
              <div className="NutritionFacts-rowLabel">{entry.name}</div>
              <div className="NutritionFacts-rowValue">
                {renderValue(nutritionalValue[entry.id], entry.unit)}
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
